import { Component, default as React } from "react";
import { formatNumber } from "../utils/NumberUtils";
import TimeUtils from "../utils/TimeUtils";

interface SimpleStatsProps {
	title: string;
	value?: number;
	time?: number;
}

class SimpleStatsBox extends Component<SimpleStatsProps, any> {

	public render() {
		return (
			<div className="col-sm-6 col-xl-3" data-toggle="appear">
				<div className="block block-rounded">
					<div className="block-content block-content-full">
						<div className="font-size-lg font-w700 mb-3">{this.props.title}</div>
						{
							this.props.time == null ?
								<div
									className="text-black font-size-h1 font-w700">{formatNumber(this.props.value)}</div>
								: <div
									className="text-black font-size-h1 font-w700">{TimeUtils.convertTime(this.props.time)}</div>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default SimpleStatsBox;
